// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Home-Main-index-root-ODeca","panel":"src-components-Home-Main-index-panel-2OhgT","panelTitle":"src-components-Home-Main-index-panelTitle-p2KxJ","panelList":"src-components-Home-Main-index-panelList-2v97R","panelItem":"src-components-Home-Main-index-panelItem-kkzMX","panelItemActive":"src-components-Home-Main-index-panelItemActive-2-iqD src-components-Home-Main-index-panelItem-kkzMX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home/Main/index.css
 ** module id = 53
 ** module chunks = 0
 **/